import { Component, OnInit, NgZone } from '@angular/core';
import { TitleService } from '@app/shared/services/title.service';
import { MenuService } from '@app/shared/services/menu.service';
import { FormBuilder } from '@angular/forms';
import { ReservationsService } from '@app/shared/services/reservations.service';
import { AlertService } from '@app/shared/services/alert.service';
import { SocietiesService } from '@app/shared/services/societies.service';
import { PdfService } from '@app/shared/services/pdf.service';

@Component({
  selector: 'app-reservation-invoices',
  templateUrl: './reservation-invoices.component.html',
  styleUrls: ['./reservation-invoices.component.scss']
})
export class ReservationInvoicesComponent implements OnInit {

  public invoices : any = [];
  public society : any = {};
  public page : number = 1;
  public societySearch : string = '';
  public societySelected : number = 6;
  public societyOptions : any = [];
  public societyDisplay : boolean = false;
  public societyNoResult : boolean = false;
  public societyLoading : boolean = false;
  public _timeout : any = null;

  public moreResultsAvailable : boolean = true;
  public noResult : boolean = false;
  public loadingStatus : boolean = true;

  constructor(
    private titleService: TitleService,
    private menu: MenuService,
    private societyService: SocietiesService,
    private reservationService: ReservationsService,
    private pdfService: PdfService,
    private lc: NgZone
  ) { }

  ngOnInit() {
    this.titleService.setTitle(`Liste des virements / VOP`);
    this.menu.setMenuState('reservation', 'invoice', '');
    this.search(1, true);
  }

  updateSocietyOptionList(event) {
    if (this._timeout) {
      window.clearTimeout(this._timeout);
    }
    this._timeout = window.setTimeout(() => {
      this._timeout = null;
      this.lc.run(() => {
        this.societySearch = event;
        this.societyLoading = true;
        this.societyNoResult = false;
        this.societyService.updateSocieties(1, this.societySearch).then((res) => {
          if (res.length > 0) {
            this.societyOptions = res;
          } else {
            this.societyNoResult = true;
          }
          this.societyLoading = false;
        });
      });
    }, 1000);
  }

  setSocietySearch(option) {
    this.societySearch = option.Code;
    this.societySelected = option.Id;
  }

  toggleSuggestions(shouldDisplay) {
    setTimeout(() => {
      this.societyDisplay = shouldDisplay;
    }, 250);
  }

  search(page : number, initialSearch? : boolean) {
    this.page = page;
    if (initialSearch === true) {
      this.loadingStatus = true;
      this.invoices = [];
      this.moreResultsAvailable = true;
      this.page = 1;
    }
    this.societyService.getSociety(this.societySelected).then((res) => {
      if (initialSearch === true) {
        this.society = res;
      }
      this.societyService.getSocietyInvoices(this.societySelected, this.page).then((res) => {
        if (initialSearch === true && res.length === 0) {
          this.loadingStatus = false;
          this.noResult = true;
        }
        if (res.length > 0) {
          res.forEach((invoice) => {
            this.invoices.push(invoice);
          });
        } else {
          this.moreResultsAvailable = false;
        }
      });
    });
  }

  downloadInvoice(idInvoice) {
    this.reservationService.getReservationInvoice(idInvoice).then((res) => {
      this.pdfService.setFile(res.file).then((file) => {
        this.pdfService.downloadFile(res.filename);
      })
    });
  }

}
